export default __webpack_public_path__ + "static/media/slider-1.28df1ae4.png";